import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from '../../../utils/colors';
import { StyledCard, useScheduleCardStyles } from './styles';
import dayjs from 'dayjs';
import { useBookingsContext } from '../../../contexts/BookingsContext';
import { BOOKING_STATUS } from '../../../global/constants/status';
import ShareIcon from '../../../icons/ShareIcon';
import { IBooking } from '@homeporter/types';

interface IProps {
  booking: IBooking;
  tab?: string;
}

const ScheduleCard = ({ booking }: IProps) => {
  const scheduleCardStyles = useScheduleCardStyles();
  const { booking_date, title, address, booking_id } = booking;
  const { selectedBooking, setSelectedBooking } = useBookingsContext();
  const isSelected = selectedBooking?.booking_id === booking_id;
  const isCancelled = booking.status === BOOKING_STATUS.SESSION_CANCELED;
  const isExported = booking.status === BOOKING_STATUS.EXPORTED;

  return (
    <StyledCard
      onClick={(e) => {
        e.stopPropagation();
        setSelectedBooking(booking);
      }}
      sx={{
        backgroundColor:
          isSelected && isCancelled
            ? 'rgba(229, 79, 81, 0.3)'
            : isCancelled
              ? 'rgba(229, 79, 81, 0.1)'
              : isExported
                ? 'rgba(79, 229, 81, 0.1)'
                : isSelected
                  ? COLORS.SELECTED
                  : COLORS.LIGHT_GRAY,
      }}>
      <Typography
        fontSize="1.3125rem"
        fontWeight="bold"
        color={COLORS.TEXT}
        minWidth="15%">
        {`${dayjs(booking_date).format('HH:mm')} `}
      </Typography>
      <Box flexGrow={1}>
        <Typography fontSize={'0.875rem'} fontWeight={600} color={COLORS.TEXT}>
          {title}
        </Typography>
      </Box>
      <Box>
        <Typography
          fontSize={'.75rem'}
          paddingRight={'1rem'}
          color={COLORS.MEDIUM_GRAY}
          textTransform={'capitalize'}>
          {`${
            Object.keys(booking?.tasks || []).length
              ? Object.keys(booking?.tasks || []).join(', ')
              : booking?.payment?.plan?.label
          }`}
        </Typography>
      </Box>
      {(!booking.owner || (booking?.shared_with || []).length > 0) && (
        <ShareIcon
          sx={{
            color: COLORS.MEDIUM_GRAY,

            right: 0,
            top: 0,
          }}
        />
      )}
    </StyledCard>
  );
};

export default ScheduleCard;
